<div class="index-selector">
  <button
    mhFilterTrigger
    [filterOpen]="isOpen"
    (click)="toggleOpen()" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
    id="indexSelectorTrigger"
  >
    <!-- En móvil el control es un círculo con solo el ícono -->
    <i class="fas fa-chart-line tw-text-neutral-500 md:tw-hidden"></i>
    <span class="tw-hidden tw-max-w-64 tw-truncate tw-font-medium md:tw-block">
      {{ selectedOptionLabel | translate }}
    </span>
    <i class="fal fa-angle-down tw-hidden tw-text-base tw-ml-1 tw-text-neutral-400 md:tw-inline"></i>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
  >
    <article class="tw-rounded-lg tw-shadow-xl tw-p-3 tw-bg-white tw-mt-1 tw-max-h-[300px] tw-overflow-y-auto tw-w-[300px]" id="indexSelectorMenu">
      <mat-radio-group class="tw-flex tw-flex-col tw-w-full" [(ngModel)]="selectedOption" (change)="selectOption($event.value)">
        <mat-radio-button class="tw-my-1" *ngFor="let option of options" [value]="option.id">
          {{ option.label | translate }} <span *ngIf="option.hasNewTag" class="tw-bg-green-600 tw-rounded-full tw-px-1 tw-text-xs tw-text-white">{{ 'commons.new' | translate }}</span>
        </mat-radio-button>
      </mat-radio-group>
    </article>
  </ng-template>
</div>
